module.exports = __webpack_public_path__ + "img/voet_logo-1405x41.6a206d95.svg";